import { useAccount } from '@bnnvara/accounts';
import PropTypes from 'prop-types';
import React from 'react';

import { PersonalizedRecommendationQuery } from '../../../api/queries/recommendation.gql';
import PageQuery from '../../PageQuery';
import RecommendationBlock from '../RecommendationBlock';

const PersonalizedRecommendation = ({ id }) => {
  const {
    profile: { UID },
  } = useAccount();

  return (
    <PageQuery
      query={PersonalizedRecommendationQuery}
      variables={{
        userId: UID,
        itemId: id,
        paginator: { limit: 4 },
      }}
    >
      {({ data }) => {
        const { edges, type } = data.personalizedRecommendation;

        return (
          edges?.length > 0 && (
            <RecommendationBlock
              results={edges}
              title={
                type === 'personal'
                  ? 'Geselecteerd voor jou'
                  : 'Meer over dit onderwerp'
              }
              recomType={
                type === 'personal' ? 'gepersonaliseerd' : 'gerelateerd'
              }
            />
          )
        );
      }}
    </PageQuery>
  );
};

PersonalizedRecommendation.propTypes = {
  id: PropTypes.string.isRequired,
};

export default PersonalizedRecommendation;
